import DynamicDownload from '@/components/DynamicDownload';
import type { chargesSearchSchemaType } from '@/modules/sales/charges/route';
import type { paymentsSearchSchemaType } from '@/modules/sales/payments/route';
import { queryClient } from '@/query-client';
import { getCmsUserGroups } from '@/services/cms';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import { Outlet, useLocation } from '@tanstack/react-router';

import { salesRoute } from './route';

export const SalesLayout = () => {
  // * Prefetch user groups as before, this should be moved to router loaders in the future
  void queryClient.prefetchQuery({
    queryKey: ['user_groups'],
    queryFn: async () => await getCmsUserGroups(),
    staleTime: Infinity,
  });

  const navigate = salesRoute.useNavigate();
  const location = useLocation();

  const currentTab: 'charges' | 'payments' = location.pathname.includes('/sales/charges')
    ? 'charges'
    : 'payments';

  return (
    <>
      <div className="$tw-flex $tw-h-full $tw-flex-col $tw-gap-2">
        <Tabs value={currentTab}>
          <TabsList className="$tw-bg-muted/50">
            <TabsTrigger
              value="charges"
              onClick={() =>
                void navigate({ to: '/sales/charges', search: {} as chargesSearchSchemaType })
              }
            >
              Cargas
            </TabsTrigger>
            <TabsTrigger
              value="payments"
              onClick={() =>
                void navigate({ to: '/sales/payments', search: {} as paymentsSearchSchemaType })
              }
            >
              Cobros
            </TabsTrigger>
          </TabsList>
        </Tabs>
        <Outlet />
      </div>
      <DynamicDownload />
    </>
  );
};
